export default function InstallPrompt (NetteAjax) {
  return NetteAjax.ext({
    before: function (settings) {
      if (!settings.nette) {
        return
      }

      const question = settings.nette.ui.getAttribute('data-prompt')
      if (question) {
        let defaultValue = ''
        if (settings.nette.ui.hasAttribute('data-prompt-val')) {
          defaultValue = settings.nette.ui.getAttribute('data-prompt-val')
        }
          
        const response = prompt(question, defaultValue)
        if (response === null) {
          return false
        }

        const promptParamName = settings.nette.ui.hasAttribute('data-prompt-param')
          ? settings.nette.ui.getAttribute('data-prompt-param')
          : 'prompt'
        
        if (!settings.params) {
          settings.params = {}
        }

        settings.params[promptParamName] = response
      }
    }
  }, {
    install(Vue/*, context*/) {
      Vue.directive('link-prompt', {
        mounted(el, binding) {
          const config = {
            defaultValue: '',
            param: 'prompt',
            question: '?'
          }
          if (typeof binding.value === 'string') {
            config.question = binding.value
          
          } else if (typeof binding.value === 'object') {
            if (typeof binding.value.defaultValue !== 'undefined') {
              config.defaultValue = binding.value.defaultValue
            }

            if (typeof binding.value.param !== 'undefined') {
              config.param = binding.value.param
            }
            
            if (typeof binding.value.question !== 'undefined') {
              config.question = binding.value.question
            }
          }

          el._promptLinkClickCallback = (ev) => {
            ev.preventDefault()

            const response = prompt(config.question, config.defaultValue)
            if (response === null) {
              return false
            }
            let url = el.href
            if (url.includes('?')) {
              url += '&'
            } else {
              url += '?'
            }

            url += config.param + '=' + response

            if (el.target === '_blank') {
              window.open(url)
            } else {
              window.location = url
            }

          }

          el.addEventListener('click', el._promptLinkClickCallback)
        },
        unmounted(el) {
          el.removeEventListener('click', el._promptLinkClickCallback)
        }
      })
    },
  })
}
